<template>
  <v-card>
    <v-card-title class="headline py-2">
      {{(editMode)?'Редактировать':'Добавить'}} папку
      <v-spacer></v-spacer>
      <v-btn icon class="mx-0" @click="$emit('close-dialog')">
        <v-icon>close</v-icon>
      </v-btn>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <dantser-tree
        label="Родительская папка"
        :source="foldersTree"
        ref="parentFolder"
        :field="true"
        :selectMode="1"
        @node-dblclick="setParent($event)">
      </dantser-tree>
      <v-text-field v-model="folder.name" label="Название"></v-text-field>
      <div class="mb-3">
        <label class="v-label theme--light" style="font-size: 13px">Описание</label>
        <dantser-editor v-model="folder.description" :init="config" :api-key="apiKey"></dantser-editor>
      </div>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions class="pa-3">
      <v-btn color="success" @click="submit" :disabled="status.btnDisabled">Сохранить</v-btn>
      <span :class="status.className" class="ml-2">{{status.text}}</span>
    </v-card-actions>
  </v-card>
</template>

<script>
  import {mapState} from 'vuex'
  
  export default {
    name : "FolderForm",
    
    props : {
      data:{
        type: Object,
        required: false,
        default: () => { return {
          name: '',
          description: '',
          parent_id: null,
        }}
      },
      parent_id:{
        type: Number,
        required: false,
        default: null
      },
      editMode: {
        type: Boolean,
        required: false,
        default: false
      },
    },
  
    computed:{
      ...mapState('orgstructure', {
        config: state => state.editorBaseConfig,
        apiKey: state => state.editorApiKey,
      }),
    },
    
    created() {
      this.folder = JSON.parse(JSON.stringify(this.data))
      this.getFolders()
      if(this.editMode){
        this.getFolder(this.folder.id)
      } else {
        this.folder.parent_id = this.parent_id
      }
    },
    
    data() {
      return {
        status : {
          btnDisabled : false,
          text : '',
          className : 'success--text darken-1'
        },
        foldersTree: [],
        folder : {}
      }
    },
    
    methods : {
      getFolders(){
        let id = this.editMode ? this.folder.id : 0
        this.$store.dispatch('orgstructure/anketa/getStatusFolders', id).then( response => {
          response.unshift({ id: 0, name: 'Не выбрано', icon: 'mdi mdi-square' })
          this.foldersTree = response
          this.$nextTick(function(){
            if(this.folder.parent_id!=null){
              this.$refs['parentFolder'].setSelected(this.folder.parent_id)
            } else {
              this.$refs['parentFolder'].setSelected(0)
            }
          })
        })
      },
  
      setParent(eventData){
        this.folder.parent_id = eventData.id
      },
  
      getFolder(id){
        this.$store.dispatch('orgstructure/anketa/getStatusFolder', id).then( folder => {
          this.folder.description = folder.description
        })
      },
      
      submit() {
        this.status = { btnDisabled : true, text : 'Сохранение', className : 'secondary--text lighten-1' }
        
        if( this.editMode ) {
          this.$store.dispatch( 'orgstructure/anketa/updateStatusFolder', this.folder ).then( response => {
            this.status = { btnDisabled : false, text : 'Сохранено', className : 'success--text darken-1' }
            this.$emit( 'close-dialog' )
          } ).catch( error => {
            this.status = { btnDisabled : false, text : 'Ошибка', className : 'error--text darken-1' }
          } )
        } else {
          this.$store.dispatch( 'orgstructure/anketa/createStatusFolder', this.folder ).then( response => {
            this.status = { btnDisabled : false, text : 'Сохранено', className : 'success--text darken-1' }
            this.$emit( 'close-dialog' )
          } ).catch( error => {
            this.status = { btnDisabled : false, text : 'Ошибка', className : 'error--text darken-1' }
          } )
        }
      }
    }
    
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/apps/org/components/Anketa/Forms/FolderForm.vue